import React from "react";
import {Helmet} from "react-helmet";
import IdpCollegeForms from "../../components/idp-school/idpSchoolContainer";
// import MedicineForm from "../../../src/client/components/idp-medicine/form";
import "../../assets/css/idp-medical.css";
import QuestionCounter from "../../components/common/questionCounter";

const IdpSchool = () => {
  return (<>
    <Helmet>
        <title>IDP School</title>
    </Helmet>
    <div className="idp_wrapper">
      <div className="idp_container">
        <div className="idp_bg_wrapper">
          <div className="idp_map_inner column_direction">
            <div className="idp_hading_block idp_school_hading_block">
              <div className="logo_blk">
                <img src={require("../../assets/images/logo.png")} alt="" />
              </div>
              <h1>Confused About Your Career Path?</h1>
              <p>We can help..</p>
            </div>
            <img src={require("../../assets/images/school-left-img.png")} width={530} alt="" />
          </div>
        </div>
        <div className="idp_form_wrapper">
          <div className="idp_abrod_about_us">
            <h2 className="about_us_heading">
              Help us <strong>Personalize</strong> your{" "}
              <br /><strong>experience</strong>
            </h2>
            {/* <QuestionCounter strokeWidth={10} percentage={50} bgColor="#cccccc" fcolor="#d0f45b" /> */}
            <p className="idp_breif">Fill in the information and to help us make your career journey smoother.</p>
          </div>

          <IdpCollegeForms/>
        </div>
      </div>
    </div>
    </>);
};

export default IdpSchool;
